export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/originals.20fcba61.svg","height":65,"width":879};